<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.sidemenu.term_cond"
            small
            multiLineTitle
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-6"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0">

            <div class="">
                <div class="text-base h-full overflow-y-auto pb-5" v-html="termsContent"></div>
            </div>

        </PageContent>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: 'Terms',
    components: {
        TopBarBg,
        PageContent,
    },
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            termsContent: '',
            termsVersion: 0,

            modalController: null,
        };
    },
    created: function() {
        this.setupTerms();

        this.modalController.setAlertModal(this.alertModal);
    },
    methods: {
        setupTerms: async function() {
            await this.apiGetTermsVersion();
            await this.apiGetTermsContent();
        },

        apiGetTermsVersion: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe((data) => {
                    this.termsVersion = data.terms.current_version;
                    resolve(data);
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
        apiGetTermsContent: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAContent('terms', this.termsVersion, this.localeCode + '.txt')
                    .subscribe((data) => {
                        this.termsContent = data;
                        resolve(data);
                    }, (err) => {
                        this.errorApi(err);
                        reject(err);
                    });
            });
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
